export default "__VITE_ASSET__DaqlqpJk__"